export default __webpack_public_path__ + "static/kontakt-4baf781bffb2ee0da37157f8caa962be.webp";